<template>
  <v-form class="form glass-element" v-model="valid">
    <h2>
      Edit my profile info <small>({{ ownProfile.username }})</small>
    </h2>

    <v-text-field
      v-model="formData.username"
      id="username"
      label="Username"
      :rules="usernameRules"
    ></v-text-field>

    <v-text-field
      v-model="formData.email"
      id="email"
      type="email"
      label="e-mail"
      :rules="emailRules"
    ></v-text-field>

    <v-text-field
      v-model="formData.first_name"
      id="first_name"
      type="text"
      label="First name"
    ></v-text-field>
    <v-text-field
      v-model="formData.last_name"
      id="last_name"
      type="text"
      label="Last name"
    ></v-text-field>

    <v-divider></v-divider>
    <div class="form-actions-container">
      <v-btn
        class="form-actions first-action"
        @click="updateProfile"
        v-if="!loading"
        >Update my profile info</v-btn
      >
      <SmallLoaderLight class="form-loader" v-if="loading" />
      <div v-if="response">
        <v-alert type="success" dismissible transition="scale-transition">
          Profile udpated.
        </v-alert>
      </div>
    </div>
  </v-form>
</template>

<script>
import SmallLoaderLight from "@/components/atoms/SmallLoaderLight";
import { mapState } from "vuex";
import { profileGetMiscellaneousIdsList } from "@/utils/profiles.util";

export default {
  components: { SmallLoaderLight },
  data() {
    return {
      loading: false,
      response: null,
      valid: true,
      usernameRules: [
        (v) => !!v || "Username is required",
        (v) => (v && v.length > 4) || "Name must be more than 4 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      formData: {
        pk: null,
        username: null,
        email: null,
        first_name: null,
        last_name: null,
      },
    };
  },
  computed: mapState({
    ownProfile: (state) => state.profiles.ownProfile,
    validForm(state) {
      return this.formData != state.ownProfile;
    },
  }),
  methods: {
    updateProfile() {
      this.loading = true;
      this.response = null;
      let profile = this.formData;
      profile = profileGetMiscellaneousIdsList(profile);
      this.$store.dispatch("updateProfile", profile).then((data) => {
        this.response = data;
        this.$store.dispatch("getOwnProfile");
        this.loading = false;
      });
    },
  },
  mounted() {
    this.$store.dispatch("getOwnProfile");
    this.formData = { ...this.ownProfile };
  },
};
</script>
